// extracted by mini-css-extract-plugin
export default {"authLayout_main_root_wrapper":"AuthLayout_authLayout_main_root_wrapper__Fy7ax"};